export const SET_TICKET_LIST = "SET_TICKET_LIST";

export const setTicketList = (ticketListState) => (dispatch) => {
  dispatch({ type: SET_TICKET_LIST, payload: ticketListState });
}